import React from 'react';
import { Carousel } from '@one-thd/sui-carousel';
import {
  Card, CardTitle, Badge, Typography, Button, CardBody,
} from '@one-thd/sui-atomic-components';
import { ArrowForward } from '@one-thd/sui-icons';
import { bool, arrayOf, shape } from 'prop-types';
import { ProjectTile } from '../project-tile/ProjectTile';
import { PROJECT_ENTRY_POINT, MAX_PROJECTS_TO_SHOW_IN_CAROUSEL } from '../project-summary-helper';
import { triggerAnalytics } from '../../helpers';

export const FullStateCarouselCard = ({ loading, projects, shouldShowBadge }) => {
  const carouselItems = projects?.length > MAX_PROJECTS_TO_SHOW_IN_CAROUSEL
    ? MAX_PROJECTS_TO_SHOW_IN_CAROUSEL : projects?.length;
  const projectsToShow = projects?.slice(0, carouselItems);

  const cardContent = projectsToShow?.map((project) => (
    <ProjectTile
      key={project.projectId}
      projectId={project.projectId}
      project={project}
      loading={loading}
      disableAction
      onClick={() => triggerAnalytics(PROJECT_ENTRY_POINT, { entryPoint: 'project name' })}
    />
  ));
  return (
    <Card
      data-testid="projects-carousel-card"
      grow
      PaperProps={{ className: 'sui-flex' }}
    >
      <FullStateCarouselCardHeader shouldShowBadge={shouldShowBadge} />
      <CardBody>
        <div data-testid="projects-content-carousel">
          <Carousel slidesPerView={1}>
            {cardContent}
          </Carousel>
        </div>
      </CardBody>
    </Card>
  );

};

const FullStateCarouselCardHeader = ({ shouldShowBadge }) => {
  return (
    <CardTitle
      data-testid="projects-header-carousel"
      header={(
        <>
          {shouldShowBadge && (
            <div className="sui-mb-2">
              <Badge data-testid="beta-badge" variant="regular" color="info">Beta</Badge>
            </div>
          )}
          <Typography data-testid="card-title" height="tight" variant="h3" weight="bold">
            Projects
          </Typography>
        </>
      )}
      disableActionSpacing
      actionPosition="center"
      action={(
        <Button
          tabIndex={0}
          onClick={() => triggerAnalytics(PROJECT_ENTRY_POINT, { entryPoint: 'view all' })}
          className="sui-flex"
          data-testid="projects-view-all"
          variant="ghost"
          href="/projects"
        >
          <ArrowForward
            iconSize="regular"
          />
        </Button>
      )}
    />
  );
};

FullStateCarouselCardHeader.propTypes = {
  shouldShowBadge: bool,
};

FullStateCarouselCardHeader.defaultProps = {
  shouldShowBadge: false,
};

FullStateCarouselCard.propTypes = {
  shouldShowBadge: bool,
  projects: arrayOf(shape({})),
  loading: bool
};

FullStateCarouselCard.defaultProps = {
  shouldShowBadge: false,
  projects: [],
  loading: false
};
